import { connect } from 'react-redux';
import challengeActions from '../../store/actions/challenge.action';
import SecurityFactors from './SecurityFactors';

const mapStateToProps = state => ({
  challenges: state.challenge.challenges,
  isChallengeValid: state.challenge.isChallengeValid,
  isSmsRequestValid: state.challenge.isSmsRequestValid
});

const mapDispatchToProps = dispatch => {
  return {
    closeChallenge: () => {
      dispatch(challengeActions.closeChallenge());
    },
    getSMSChallenge: () => {
      dispatch(challengeActions.getSMSChallenge());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SecurityFactors);
